import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export default function LoginReportModal({ onClose }) {
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/users/login-report`)
      .then(res => setReport(res.data))
      .catch(() => setError('Could not load login activity.'))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (value) => {
    if (!value) return 'Never';
    return new Date(value).toLocaleString('en-GB');
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3 style={{ marginTop: 0 }}>Login Activity</h3>

        {loading && <p style={{ color: '#ccc' }}>Loading...</p>}
        {error && <p style={{ color: '#ff6b6b' }}>{error}</p>}

        {!loading && !error && (
          <div style={{ maxHeight: '55vh', overflowY: 'auto' }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>NAME</th>
                  <th style={thStyle}>ROLE</th>
                  <th style={thStyle}>LAST LOGIN</th>
                  <th style={thStyle}>STATUS</th>
                </tr>
              </thead>
              <tbody>
                {report.map(r => (
                  <tr key={r.id}>
                    <td style={tdStyle}>{r.name}</td>
                    <td style={tdStyle}>{r.role}</td>
                    <td style={tdStyle}>{formatDate(r.last_sign_in_at)}</td>
                    <td style={tdStyle}>
                      {!r.is_active ? 'DEACTIVATED' : !r.linked ? 'NO LOGIN LINKED' : r.last_sign_in_at ? 'ACTIVE' : 'NEVER LOGGED IN'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={actionsStyle}>
          <button type="button" onClick={onClose} style={primaryBtnStyle}>CLOSE</button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center',
  justifyContent: 'center', zIndex: 1000,
};
const modalStyle = {
  background: '#1a1a1a', color: '#fff', padding: '2rem', borderRadius: '8px',
  width: '560px', maxWidth: '90vw', borderTop: '3px solid #f2b705',
};
const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' };
const thStyle = { textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid #444', color: '#ccc', fontSize: '0.75rem', letterSpacing: '0.05em' };
const tdStyle = { padding: '0.5rem', borderBottom: '1px solid #2a2a2a' };
const actionsStyle = { display: 'flex', justifyContent: 'flex-end', marginTop: '1.25rem' };
const primaryBtnStyle = {
  padding: '0.6rem 1.2rem', background: '#f2b705', border: 'none',
  color: '#111', fontWeight: 'bold', borderRadius: '4px', cursor: 'pointer',
};
